<template>
  <div>
    <h2 class="pb-5">Payment Information</h2>
    <h2 class="text-xl font-semibold my-3">
      Activation fee -
      {{
        getCurrentUser.landlord.payments_activation_fee_paid
          ? "Paid"
          : getUserAccountInfo.mode === "edit"
          ? "$5.00"
          : "$50.00"
      }}
    </h2>
    <div class="py-3">
      <p class="">
        Note: It may take a few moments for your payment to process. Please do NOT press the back
        button or refresh this page.
      </p>
    </div>

    <div class="py-3" v-if="!getCurrentUser.landlord.payments_activation_fee_paid">
      <label class="block"> Credit card number </label>
      <CardInput class="py-2" ref="card" @validate="validateInput" />

      <div class="flex pt-2">
        <input
          id="card-box"
          type="checkbox"
          class="h-5 w-5 rounded-sm border-gray-300 text-brand-green focus:ring-brand-green"
          v-model="receipt"
        />
        <label for="card-box" class="ml-2 text-sm text-brand-mid-gray italic"
          >I want to receive a receipt for this payment</label
        >
      </div>
    </div>

    <div class="flex flex-col py-5">
      <p v-if="errorMessage" class="text-brand-red pb-2 text-center">
        {{ errorMessage }}
      </p>
      <div class="w-full md:w-1/3 md:mx-auto">
        <PrimaryButton
          @click="pay"
          :disabled="!isInputValid || isStripeLoading || isUserLoading"
          :is-loading="isStripeLoading || isUserLoading"
          >Submit Payment
        </PrimaryButton>
      </div>
    </div>
    <div class="mx-auto w-80 pt-5"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { USER_SETUP_BANK_ACCOUNT_INFO } from "@/store/types"

export default {
  computed: {
    ...mapGetters(["getUserAccountInfo", "isUserLoading", "getCurrentUser"])
  },
  async mounted() {
    if (!this.getUserAccountInfo) {
      this.$router.push({
        name: "dashboard_my_payments_signup_bank_account_info"
      })
    }

    if (this.getCurrentUser.landlord.payments_activation_fee_paid) {
      await this.$store.dispatch(USER_SETUP_BANK_ACCOUNT_INFO, {
        data: this.getUserAccountInfo,
        receipt: false
      })

      this.$router.push({ name: "dashboard_my_payments_signup_complete" })
    }
  },
  data() {
    return {
      receipt: true,
      isStripeLoading: false,
      isInputValid: false,
      errorMessage: ""
    }
  },
  methods: {
    validateInput() {
      this.isInputValid = true
    },
    async pay() {
      const card = this.$refs.card.card
      const stripe = this.$refs.card.stripe

      let result
      // TODO: Display error from stripe
      try {
        this.isStripeLoading = true
        result = await stripe.createToken(card)
        this.isStripeLoading = false
      } catch (err) {
        this.errorMessage = err.response.message
        return
      }

      try {
        await this.$store.dispatch(USER_SETUP_BANK_ACCOUNT_INFO, {
          data: this.getUserAccountInfo,
          token: result.token.id,
          receipt: this.receipt
        })

        this.$router.push({ name: "dashboard_my_payments_signup_complete" })
      } catch (err) {
        const error = err.response
        //Get first error
        this.errorMessage = Object.values(error.data).flat()[0]
      }
    }
  }
}
</script>
